import React from 'react';
import { observer } from 'mobx-react';
import { useFormikContext } from 'formik';
import { makeStyles } from '@material-ui/core/styles';

import FormList from 'core/components/form-list';
import { useDisabledState } from 'common/disabled-context';
import { getAssociatedEntityOptions } from 'common/helpers/farm-helpers';
import { Locations } from './locations';
import { PolicyWideEndorsements } from './policy-wide-endorsements';
import { AddFarmInterestedPartyForm, FarmInterestedParty } from './additional-party';
import { AddMortgage, MortgageItem } from '../mortgage-details';

const useStyles = makeStyles((theme) => ({
  innerContainer: {
    padding: theme.spacing(8),
    backgroundColor: theme.colors.card_background_primary_editable,
    borderRadius: theme.sizes.roundCorners
  }
}));

function FarmOffer() {
  const { values } = useFormikContext();
  const { disabled } = useDisabledState();
  const classes = useStyles();

  const associatedEntityOptions = getAssociatedEntityOptions(values.farmLocations || []);

  return (
    <>
      <Locations />
      <PolicyWideEndorsements />
      <FormList
        key={`parties-${disabled}`}
        id="interestedParties"
        item={FarmInterestedParty}
        addForm={AddFarmInterestedPartyForm}
        title="Farm additional interested party"
        singular="Party"
        plural="Parties"
        disabled={disabled}
        associatedEntityOptions={associatedEntityOptions}
      />
      <FormList
        classes={classes}
        id="farm.mortgageDetails"
        item={MortgageItem}
        addForm={AddMortgage}
        title="Mortgage lender information"
        singular="Mortgage"
        plural="Mortgages"
        disabled={disabled}
      />
    </>
  );
}
export default observer(FarmOffer);
